import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UiTranslateModule } from '@fcom/ui-translate';
import { DirectiveModule } from '@fcom/common/directives/directive.module';

import { IconsModule } from '../icons/icons.module';
import { ButtonModule } from '../buttons/button.module';
import { NotificationComponent } from './notification/notification.component';
import { BannerNotificationComponent } from './banner/banner.component';
import { LoaderModule } from '../loader';
import { LinkModule } from '../link/link.module';
import { MenuListComponent } from './menu-list/menu-list.component';

@NgModule({
  declarations: [NotificationComponent, MenuListComponent, BannerNotificationComponent],
  imports: [CommonModule, IconsModule, ButtonModule, LoaderModule, UiTranslateModule, DirectiveModule, LinkModule],
  exports: [NotificationComponent, MenuListComponent, BannerNotificationComponent],
  providers: [],
})
export class NotificationsModule {}
